import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import { ITransportPointExtendedCell } from '../../../../../../types/newbuildingsCompare';

export interface ITransportPointExtendedCellProps {
  cell: ITransportPointExtendedCell;
}

export const TransportPointExtendedCell = ({ cell }: ITransportPointExtendedCellProps): React.JSX.Element => (
  <Body2>{cell.data?.transportPoints.map(point => point.name).join(', ') ?? cell.state.text ?? ''}</Body2>
);
